import React from 'react';
import { motion } from 'framer-motion';

const SuccessScreen = ({ onRegisterAnother, onClose }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
      className="text-center py-16"
    >
      <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-100 mb-6">
        <svg className="h-10 w-10 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      
      <h2 className="text-2xl font-bold text-gray-900 mb-2">Registration Complete!</h2>
      
      <p className="text-gray-600 mb-8 max-w-md mx-auto">
        Thank you for completing the patient registration form. Your information has been successfully submitted.
      </p>
     
      
      <div className="flex gap-4 justify-center mt-8">
        <motion.button
          type="button"
          className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={onRegisterAnother}
        >
          Register Another Patient
        </motion.button>
        <motion.button
          type="button"
          className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={onClose}
        >
          Close
        </motion.button>
      </div>
    </motion.div>
  );
};

export default SuccessScreen;

